import React, { useEffect, useState } from 'react';
import { Button, Form, FormControl, InputGroup } from 'react-bootstrap';
import { FaSearch, FaTimes } from 'react-icons/fa';
import './input-dialog.css';

type InputDlgProps = {
  id?: string;
  valueId: string;
  valueName: string;
  onDlgClick: (event: any) => Promise<{ newId: string; newName: string }>;
  onValueChange: (valueId: string, valueName: string) => void;
  disable?: boolean;
  readOnly?: boolean;
};

export const InputDlg = ({
  id,
  valueId: initValueId,
  valueName: initValueName,
  onDlgClick,
  onValueChange,
  disable = false,
  readOnly = false,
}: InputDlgProps) => {
  const [valueId, setValueId] = useState(initValueId);
  const [valueName, setValueName] = useState(initValueName);

  useEffect(() => {
    setValueName(initValueName);
  }, [initValueName]);
  useEffect(() => {
    setValueId(initValueId);
  }, [initValueId]);

  const btnDlgOnClick = async (event) => {
    const newValues = await onDlgClick({ ...event, valueId, valueName });
    if (!newValues) return; // i.e. Cancel Btn Pressed
    setValueId(newValues.newId);
    setValueName(newValues.newName);
    onValueChange(newValues.newId, newValues.newName);
  };

  const btnClearOnClick = (event) => {
    const emptyValue = null;
    setValueId(emptyValue);
    // setValueName(undefined);
    setValueName('');
    onValueChange(emptyValue, '');
  };

  const btnStyle = {
    border: '1px solid #ced4da',
    backgroundColor: '#fdfdfd',
  };

  // return (
  //   <div className="input-dialog input-group">
  //     <input
  //       id={id}
  //       className="form-control"
  //       value={valueName}
  //       disabled={disable}
  //       readOnly={readOnly}
  //     ></input>
  //     <div className="input-group-append">
  //       {/* Button Clear */}
  //       <Button
  //         variant="outline-secondary"
  //         id="button-dlg-clear"
  //         className="pt-1 pb-1"
  //         onClick={btnClearOnClick}
  //         // style={btnStyle}
  //       >
  //         <FaTimes />
  //       </Button>
  //       {/* Button  Φακός */}
  //       <Button
  //         variant="outline-secondary"
  //         id="button-dlg-select"
  //         className="pt-1 pb-1"
  //         onClick={btnDlgOnClick}
  //         // style={btnStyle}
  //       >
  //         <FaSearch />
  //       </Button>
  //     </div>
  //   </div>
  // );
  return (
    <InputGroup>
      <FormControl
        id={id}
        className="form-control"
        value={valueName ?? ''}
        disabled={disable}
        readOnly={true}
      />

      {/* Button Clear */}
      <Button
        variant="outline-secondary"
        id="button-dlg-clear"
        className="pt-1 pb-1"
        onClick={btnClearOnClick}
        // style={btnStyle}
        size="sm"
        style={{ maxHeight: '22px' }}
      >
        <FaTimes size="0.9rem" style={{ marginBottom: '11px', verticalAlign: 'top' }} />
      </Button>
      {/* Button  Φακός */}
      <Button
        variant="outline-secondary"
        id="button-dlg-select"
        className="pt-1 pb-1"
        onClick={btnDlgOnClick}
        // style={btnStyle}
        size="sm"
        style={{ maxHeight: '22px' }}
      >
        <FaSearch size="0.9rem" style={{ marginBottom: '11px', verticalAlign: 'top' }} />
      </Button>
    </InputGroup>
  );
};
